<template>
  <button @click="newSheet" :aria-label="$t('sidebar.newSheet') || 'Nueva hoja de cálculo'" :title="$t('sidebar.newSheet') || 'Nueva hoja de cálculo'" class="action" id="new-sheet-button">
    <grid-icon size="1.5x" class="custom-class"></grid-icon>
    <span>{{ $t('sidebar.newSheet') || 'Hoja de cálculo' }}</span>
  </button>
</template>

<script>
import { GridIcon } from 'vue-feather-icons';

export default {
  name: 'new-sheet-button',
  components: {
    GridIcon,
  },
  methods: {
    newSheet () {
      // El prompt NewFile sabe qué tipo crear por el estado showData
      this.$store.commit('showHover', { prompt: 'newFile', confirm: null, action: null, props: null, data: { fileType: 'xlsx' } });
    },
  },
};
</script>
